import React, { useState } from 'react';
import './OrgRequestDialog.css';

const OrgRequestDialog = ({ onSubmit, onCancel, orgType }) => {
  const [orgName, setOrgName] = useState('');
  const [creatorName, setCreatorName] = useState('');
  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!orgName.trim()) {
      newErrors.orgName = 'Organization name is required';
    }
    if (!creatorName.trim()) {
      newErrors.creatorName = 'Your name is required';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onSubmit(orgName.trim(), creatorName.trim());
  };

  const orgTypeLabel = orgType === 'on_campus_org'
    ? 'On-Campus Organization'
    : 'University/College';

  return (
    <div className="dialog-overlay">
      <div className="dialog-content org-request-dialog">
        <h2>Create Organization</h2>
        <p className="dialog-question">
          Please provide the following information to create your {orgTypeLabel.toLowerCase()}.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="orgName">
              Organization Name <span className="required">*</span>
            </label>
            <input
              id="orgName"
              type="text"
              value={orgName}
              onChange={(e) => {
                setOrgName(e.target.value);
                if (errors.orgName) {
                  setErrors({ ...errors, orgName: null });
                }
              }}
              placeholder="e.g., University of Pennsylvania"
              className={errors.orgName ? 'error' : ''}
            />
            {errors.orgName && (
              <span className="error-message">{errors.orgName}</span>
            )}
            <small className="form-hint">
              This will be the name displayed for your organization.
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="creatorName">
              Your Name <span className="required">*</span>
            </label>
            <input
              id="creatorName"
              type="text"
              value={creatorName}
              onChange={(e) => {
                setCreatorName(e.target.value);
                if (errors.creatorName) {
                  setErrors({ ...errors, creatorName: null });
                }
              }}
              placeholder="e.g., John Smith"
              className={errors.creatorName ? 'error' : ''}
            />
            {errors.creatorName && (
              <span className="error-message">{errors.creatorName}</span>
            )}
            <small className="form-hint">
              This will identify the person creating the organization.
            </small>
          </div>

          <div className="dialog-buttons">
            <button type="button" onClick={onCancel} className="dialog-button cancel-button">
              Cancel
            </button>
            <button type="submit" className="dialog-button submit-button">
              Create Organization
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OrgRequestDialog;
